//#region IMPORT
import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
/** Services Import */
import Global from '../../../../../Services/Common/Global';
import { useSelector } from 'react-redux';

/** Components Import */
import M_TRA_BASIC_02 from './M_TRA_BASIC_02';
import { Loading } from '../../../../../Components/MUIs';
import { useDispatch } from 'react-redux';
import { showSnackbar } from '../../../../../Reducer/SnackbarReducer';
import Commons from '../../../../../Services/Common/Common';
import { useAppNavigate } from '../../../../../Hooks/back/useAppNavigate';
import { useBackStack } from '../../../../../Hooks/back/useBackStack';
//#endregion

function M_TRA_BASIC_02Function(props) {
  //#region 변수
  const { id } = useParams();
  const dispatch = useDispatch();
  const { navigate } = useAppNavigate();
  const [loading, setLoading] = useState(false);
  const { userInfo, lanInfo } = useSelector((state) => state.BaseInfo);
  //로그인한 user 정보
  const [inputs, setInputs] = useState({
    video: '',
    isNext: false,
  });
  const videoRef = useRef();
  const [played, setPlayed] = useState(0);
  const [play, setPlay] = useState(false);
  //#endregion

  // 스택형 뒤로가기로 변경: 교육 동영상 화면에서는 교육 목록으로 복귀
  useBackStack({
    type: 'navigate',
    onBack: () => navigate('/M_TrainingPage'),
  });

  useEffect(() => {
    Init();

    const timeout = setTimeout(() => {
      setPlay(true);
    }, 1000);

    return () => {
      clearTimeout(timeout);
    };
  }, [dispatch]);

  const Init = async () => {
    setLoading(true);
    try {
      await SearchLogic1();
    } catch (e) {
      console.log(e);
      dispatch(
        showSnackbar({
          message: e.message,
          type: 'error',
        })
      );
    } finally {
      setLoading(false);
    }
  };
  //#region 조회
  // 동영상 조회
  const SearchLogic1 = async () => {
    setLoading(true);
    setInputs({
      ...inputs,
      video: '',
      isNext: true,
    });

    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_M_TRA_BASIC_01_R1',
            _DEP_CD: Commons.EncryptAES(id) || '',
          },
        ]
      ).then((result) => {
        let data = result.data;
        if (data[0].type === 'Error') {
          throw new Error(data[0].message);
        } else {
          if (!data[0].VIDEO_LOCATION) {
            setInputs({
              ...inputs,
              video: '',
              isNext: true,
            });
          } else {
            const videoPath = data[0].VIDEO_LOCATION || '';
            const videoFullUrl = getFullFileUrl(videoPath);
            setInputs((prev) => ({
              ...prev,
              video: videoFullUrl,
            }));
          }
        }
      });
    } catch (e) {
      console.log(e);
      dispatch(
        showSnackbar({
          message: e.message,
          type: 'error',
        })
      );
    } finally {
      setLoading(false);
    }
  };
  //#endregion
  //#region 저장
  //#endregion
  //#region 삭제
  //#endregion
  //#region 나머지 함수
  // URL 인코딩 처리
  const fixUrl = (url) => {
    if (!url || typeof url !== 'string') return '';
    const parts = url.split('/');
    const fileName = parts.pop();
    const encodedFileName = encodeURIComponent(fileName);
    return [...parts, encodedFileName].join('/');
  };
  const getFullFileUrl = (relativePath) => {
    if (!relativePath) return '';
    const fixedPath = fixUrl(relativePath);
    return `${Global.file.useUrl}files/${fixedPath}`;
  };
  const HandleVideoError = (e) => {
    console.log('Video Error: ', e);
    if (e.type === 'error') {
      setInputs({
        ...inputs,
        video: '',
        isNext: true,
      });
    }
  };

  //비디오를 모두 시청 했는지 체크
  const HandleVideoEnd = () => {
    setInputs({
      ...inputs,
      isNext: true,
    });
  };

  const HandleProgress = (state) => {
    setPlayed(state.played);
  };

  const HandleSeek = (seekTime) => {
    if (!videoRef.current) return;

    try {
      const currentTime = videoRef.current.getCurrentTime();
      const duration = videoRef.current.getDuration();

      if (!duration || duration === 0) return;

      const playedFraction = currentTime / duration;
      if (playedFraction > played) {
        setPlayed(playedFraction);
      }
    } catch (error) {
      console.log('Seek Error: ', error);
    }
  };
  //#endregion

  return (
    <div className="wrap">
      <M_TRA_BASIC_02
        userInfo={userInfo}
        lanList={lanInfo}
        inputs={inputs}
        setInputs={setInputs}
        videoRef={videoRef}
        play={play}
        setPlay={setPlay}
        setModalToggle1={props.setModalToggle1}
        modalToggle1={props.modalToggle1}
        setModalToggle2={props.setModalToggle2}
        modalToggle2={props.modalToggle2}
        check={props.check}
        setCheck={props.setCheck}
        userCount={props.userCount}
        // 함수
        HandleVideoError={HandleVideoError}
        HandleVideoEnd={HandleVideoEnd}
        HandleProgress={HandleProgress}
        HandleSeek={HandleSeek}
        ActiveButton={props.ActiveButton}
      />
      <Loading open={loading} />
    </div>
  );
}

export default M_TRA_BASIC_02Function;
